export class ParametroModel {
	constructor() { }

	public Nombre: string = "";
	public IsOptional: boolean = false;
	public Tipo: string = "";
	public DefaultValue: string = "";
	public Documentacion: string = "";
}